//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';
import DpButton from '../button/Button.vue';
import DpIcon from '../icon/Icon.vue';
import SimpleInput from '../shared/simpleInput';

export default {
  name: 'DpInput',
  components: {
    DpButton,
    DpIcon,
  },
  extends: SimpleInput,
  mixins: [Tooltip],
  props: {
    size: { type: String, default: 'default' },
    errorMessage: { type: String, default: null },
    icon: { type: String, default: null },
    isNumeric: { type: Boolean, default: false },
    maxLength: { type: Number, default: null },
    hideTitle: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    v: { type: Object, default: null },
  },
  methods: {
    handleKeyPress(event) {
      if (!this.isNumeric) return true;

      const evt = event || window.event;
      const charCode = evt.which || evt.keyCode;
      // Allow decimal and negative
      if (charCode === 46 || charCode === 45) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    navigate(key) {
      this.$emit('navigate', key);
    },
  },
};
